<template>
    <cadastro-simples-list
        endpoint="almox-grupo"
        rota-base="/admin/almox-grupo"
        titulo="ALMOXARIFADO — GRUPOS DE PRODUTO"
        titulo-singular="Grupo">
    </cadastro-simples-list>
</template>
<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
